// extracted by mini-css-extract-plugin
var _1 = "ReportTableModalRow-moduleReportTableModalRow__DnIyP TableComponent-modulerow__xPAo4";
var _2 = "ReportTableModalRow-moduleresizing__ilSi5";
export { _1 as "ReportTableModalRow", _2 as "resizing" }
